<div class="container my-5">
  <h2 class="mb-4 text-center">{{ 'FAQ_TITLE' | translate }}</h2>

  <div class="accordion custom-accordion" id="faqAccordion">
    @for (category of categories; track $index; let i = $index) {
      <!-- FAQ Item 1 -->
      <h3 class="d-flex justify-content-center text-primary">{{ category.title | translate }}</h3>

      @for (faq of category.faqs; track $index; let j = $index) {
        <div class="accordion-item">
          <h2 class="accordion-header" [id]="'heading' + i + '_' + j">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              [attr.data-bs-target]="'#collapse' + i + '_' + j"
              [attr.aria-controls]="'collapse' + i + '_' + j"
              aria-expanded="false"
            >
              {{ faq.question | translate }}
            </button>
          </h2>
          <div
            [id]="'collapse' + i + '_' + j"
            class="accordion-collapse collapse"
            [attr.aria-labelledby]="'heading' + i + '_' + j"
          >
            <div class="accordion-body">
              {{ faq.answer | translate }}
            </div>
          </div>
        </div>
      }
    }
  </div>
</div>
